import isNil from 'lodash/isNil'

export const renderEntityToIdName = (entity: NullableEntity | null) => {
	if (isNil(entity)) {
		return ''
	}

	return entity.name ? `${entity.id} - ${entity.name}` : `${entity.id}`
}

export const renderEntityToCodeName = (entity: NullableNameCode | null, isDash: boolean = false) =>
	entity?.name && entity?.code ? `${entity.code} ${isDash ? '-' : ''} ${entity.name}` : ''

export const renderEntityToName = (entity: NullableEntity | null) => {
	if (isNil(entity)) {
		return ''
	}

	return entity.name ?? ''
}

export const renderEntityArrayToIdName = (entities: NullableEntity[] | null) => {
	if (isNil(entities) || entities?.length === 0) {
		return ''
	}

	return entities.map(renderEntityToIdName).join(', ')
}

export const renderEntityArrayToName = (entities: NullableEntity[] | null) => {
	if (isNil(entities) || entities?.length === 0) {
		return ''
	}

	return entities.map(renderEntityToName).join(', ')
}
